<template>
    <app-table
        :data="formItems"
        highlight-rows-on-hover
        :order="params.order"
        :page-size="params.limit"
        @sort="sortTvStations"
        :loading="listLoading"
        :more-info="false"
    >
        <template slot="header">
            <app-table-header-item class="field_left">
                <app-input
                    :label="translations.search"
                    type="search"
                    v-model="params.search"
                    @input="fetchItems(true)"
                    full-width
                />
            </app-table-header-item>
            <app-table-header-item class="field_right">
              <app-table-header-select :label="translations.inImportFilter">
                <app-select
                    id="included"
                    :options="includedOptions"
                    selectId="includedSelect"
                    name="includedSelect"
                    v-model="params.includedSelect"
                    @change="fetchItems(true)"
                />
              </app-table-header-select>
            </app-table-header-item>
        </template>

        <app-table-column
            first
            sortable
            attribute="name"
            :label="translations.name"
            :tv-station-order="this.params.tvStationOrder"
            :use-tv-station-order="true"
        >
          <template slot-scope="row">
            <strong>
              {{ row.name }}
            </strong>
          </template>
        </app-table-column>
        <app-table-column
            sortable
            attribute="importId"
            :label="translations.importId"
            :tv-station-order="this.params.tvStationOrder"
            :use-tv-station-order="true"
        />
        <app-table-column
            sortable
            attribute="existsInDatabase"
            :label="translations.existsInDb"
            :tv-station-order="this.params.tvStationOrder"
            :use-tv-station-order="true"
        >
          <template slot-scope="row">
            <app-graphic-image
                :value="row.existsInDatabase"
            />
          </template>
        </app-table-column>
        <app-table-column attribute="dbName" :label="translations.dbName">
          <template slot-scope="row">
            <a @click="goToTvStationDetail(row)" class="link">{{row.dbName}}</a>
          </template>
        </app-table-column>
        <app-table-column
            sortable
            attribute="language"
            :label="translations.language"
            :tv-station-order="this.params.tvStationOrder"
            :use-tv-station-order="true"
        />
        <app-table-column
            sortable
            attribute="importLanguage"
            :label="translations.importLanguage"
            :tv-station-order="this.params.tvStationOrder"
            :use-tv-station-order="true"
        />
        <app-table-column
            sortable
            attribute="same_language"
            :label="translations.sameLanguage"
            :tv-station-order="this.params.tvStationOrder"
            :use-tv-station-order="true"
        >
          <template slot-scope="row">
            <app-graphic-image
                :value="row.same_language"
            />
          </template>
        </app-table-column>
        <template slot="footer" v-if="itemsMetadata.totalCount > params.limit">
            <app-table-pagination
                :page="listPage"
                :itemsPerPage="params.limit"
                :totalCount="itemsMetadata.totalCount"
                @pageChanged="tablePageChanged"
            />
        </template>
        <template slot="footer">
            <button type="button" class="btn" style="margin-left: 10px;margin-top: 8px;background-color: #A2AEB7;" @click="refresh()">{{this.getButtonText}}</button>
        </template>
    </app-table>
</template>

<script>
import appTitleMixin from 'mixins/appTitleMixin'
import getItemsListMixin from 'mixins/getItemsListMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import AppCheckbox from 'components/AppCheckbox'
import { VUE_APP_BASE_AUTH_URL } from 'constants/fileConstants'
import axios from 'axios'

const itemsListMixin = getItemsListMixin({
  apiMethodsSuffix: 'EpgSources',
  enumsMap: true,
  includeParamRouteId: true,
  additionalParams: { storedTvStations: true }
})

export default {
  name: 'tv-station-base-epg-detail',
  mixins: [formatDateMixin, itemsListMixin, appTitleMixin()],
  components: { AppCheckbox },
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  created() {
    this.formItems = JSON.parse(JSON.stringify(this.items))
    if (this.params.includedSelect === '') {
      this.params.includedSelect = 'INCLUDED'
    }
  },
  data() {
    return {
      buttonText: this.$gettext('Aktualizace'),
      formItems: {}
    }
  },
  computed: {
    translations() {
      return {
        search: this.$gettext('Vyhledávání'),
        name: this.$gettext('Název'),
        importId: this.$gettext('Importní ID'),
        existsInDb: this.$gettext('Zavedeno v systému'),
        inImportFilter: this.$gettext('Obsaženo v EPG zdroji'),
        dbName: this.$gettext('Název TV stanice v DB'),
        inImportFile: this.$gettext('TV stanice v EPG zdroji'),
        notInImportFile: this.$gettext('Chybně spárované TV stanice'),
        sameLanguage: this.$gettext('Shoda jazyků'),
        importLanguage: this.$gettext('Importovaný jazyk'),
        language: this.$gettext('Jazyk TV stanice')
      }
    },
    includedOptions() {
      return [
        { name: this.translations.inImportFile + ' (' + this.itemsMetadata.includedTotalCount + ')', value: 'INCLUDED' },
        { name: this.translations.notInImportFile + ' (' + this.itemsMetadata.notIncludedTotalCount + ')', value: 'NOT_INCLUDED' }
      ]
    },
    currentTitle() {
      return [
        { name: this.$gettext('Zdroje EPG'), link: { name: 'tv-station-base-epg-detail' } },
        this.title || this.$gettext('Nový zdroj EPG')
      ]
    },
    getButtonText() {
      return this.buttonText
    }
  },
  methods: {
    refresh() {
      axios.post(VUE_APP_BASE_AUTH_URL + 'api/epg-sources/update-tv-stations/', this.params.id).then(() => {
        this.buttonText = this.$gettext('Aktualizováno')
        this.fetchItems()
      }
      )
    },
    goToTvStationDetail(tvStation) {
      this.$router.push({
        name: 'tv-station',
        params: {
          id: tvStation.tvStationId
        }
      })
    },
    sortTvStations(order) {
      const orderChanged = this.params.tvStationOrder !== order

      if (orderChanged) {
        this.params.tvStationOrder = order.order
        this.params.offset = 0
        this.listPage = 1
        this.fetchItems()
      }
    }
  },
  watch: {
    items() {
      this.formItems = JSON.parse(JSON.stringify(this.items))
    }
  }

}
</script>
